@let repasData = data();
@let onglet = repasData.ongletRepas;

@if (getHydratationLabel()) {
<div class="hydration-row">
  <mat-icon>water_drop</mat-icon>
  <span class="hydration-label">Hydratation :</span>
  <span>{{ getHydratationLabel() }}</span>
</div>
}

@for (repas of onglet.zr_petit; track $index) {
@if (repas.input_heure) {
<div class="meal-card">
  <div class="meal-header">
    <span class="time-badge secondary"><mat-icon>schedule</mat-icon>{{ repas.input_heure | carnetHeure }}</span>
  </div>
  <div class="meal-items">
    @if (repas.input_mlBiberon) {
    <div class="meal-item"><span class="label">Biberon</span><span>{{ repas.input_mlBiberon }} ml</span></div>
    }
    @if (repas.select_plat) {
    <div class="meal-item"><span class="label">Plat</span><span>{{ repas.select_plat }}</span></div>
    }
    @if (repas.select_yaourt) {
    <div class="meal-item"><span class="label">Yaourt</span><span>{{ repas.select_yaourt }}</span></div>
    }
    @if (repas.select_compoteFruit) {
    <div class="meal-item"><span class="label">Compote</span><span>{{ repas.select_compoteFruit }}</span></div>
    }
  </div>
  @if (repas.checkbox_enARedemande) {
  <div class="meal-badge-row">
    <mat-chip class="chip-small">En a redemandé !</mat-chip>
  </div>
  }
  @if (repas.input_observation) {
  <p class="meal-observation">{{ repas.input_observation }}</p>
  }
</div>
}
}

@for (repas of onglet.zr_moyenGrand; track $index) {
@if (repas.input_heure) {
<div class="meal-card">
  <div class="meal-header">
    <span class="time-badge secondary"><mat-icon>schedule</mat-icon>{{ repas.input_heure | carnetHeure }}</span>
    <span class="meal-type-label">Déjeuner</span>
  </div>
  <div class="meal-items">
    @if (repas.select_entree) {
    <div class="meal-item"><span class="label">Entrée</span><span>{{ repas.select_entree }}</span></div>
    }
    @if (repas.select_proteine) {
    <div class="meal-item"><span class="label">Protéine</span><span>{{ repas.select_proteine }}</span></div>
    }
    @if (repas.select_legume) {
    <div class="meal-item"><span class="label">Légume</span><span>{{ repas.select_legume }}</span></div>
    }
    @if (repas.select_feculent) {
    <div class="meal-item"><span class="label">Féculent</span><span>{{ repas.select_feculent }}</span></div>
    }
    @if (repas.select_plat) {
    <div class="meal-item"><span class="label">Plat</span><span>{{ repas.select_plat }}</span></div>
    }
    @if (repas.select_fromagePain) {
    <div class="meal-item"><span class="label">Fromage / Pain</span><span>{{ repas.select_fromagePain }}</span></div>
    }
    @if (repas.select_dessert) {
    <div class="meal-item"><span class="label">Dessert</span><span>{{ repas.select_dessert }}</span></div>
    }
  </div>
  @if (repas.input_observation) {
  <p class="meal-observation">{{ repas.input_observation }}</p>
  }
</div>
}
}

@if (onglet.select_produitLaitier || onglet.select_fruit || onglet.select_biscuitPain || onglet.select_autre) {
<div class="meal-card">
  <div class="meal-header">
    <span class="meal-type-label">Goûter</span>
  </div>
  <div class="meal-items">
    @if (onglet.select_produitLaitier) {
    <div class="meal-item"><span class="label">Laitier</span><span>{{ onglet.select_produitLaitier }}</span></div>
    }
    @if (onglet.select_fruit) {
    <div class="meal-item"><span class="label">Fruit</span><span>{{ onglet.select_fruit }}</span></div>
    }
    @if (onglet.select_biscuitPain) {
    <div class="meal-item"><span class="label">Biscuit / Pain</span><span>{{ onglet.select_biscuitPain }}</span></div>
    }
    @if (onglet.select_autre) {
    <div class="meal-item"><span class="label">Autre</span><span>{{ onglet.select_autre }}</span></div>
    }
    @if (onglet.input_autre) {
    <div class="meal-item"><span class="label">Précision</span><span>{{ onglet.input_autre }}</span></div>
    }
  </div>
  @if (onglet.input_observation) {
  <div class="meal-observation">{{ onglet.input_observation }}</div>
  }
</div>
}
